import { render, staticRenderFns } from "./OverviewBase.vue?vue&type=template&id=911cf04c&scoped=true&"
import script from "./OverviewBase.vue?vue&type=script&lang=js&"
export * from "./OverviewBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911cf04c",
  null
  
)

export default component.exports